// extracted by mini-css-extract-plugin
module.exports = {"container":"OverflowVerseActionsMenuBody_container__MmTNa"};